import { useForm } from 'react-hook-form';
import { INSERT_USER_AGREEMENT } from '../../config/endpoint';
import loaderService from '../../service/loaderService';
import { axiosInstance } from '../../config/axiosConfig';
import { showError } from '../../service/toastService';
import { useDispatch, useSelector } from 'react-redux';
import { getUserIsAggreed } from '../../redux/slice/userAgreementSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Consent = () => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();
    const dispatch = useDispatch();
    const isAgreed = watch('isAgreed', false);
    const navigate = useNavigate();
    const userAgreement = useSelector((state) => state.userAgreement)
    useEffect(() => {
        debugger
        if (userAgreement?.isLoaded) {
            if (userAgreement?.isAgreed != null) {
                if (userAgreement?.isAgreed) {
                    navigate('/dashboard/all-set')
                }
            }
        }

    }, [userAgreement?.isAgreed, userAgreement?.isLoaded])

    const onSubmit = async (data) => {
        try {
            loaderService.show();
            const res = await axiosInstance.post(INSERT_USER_AGREEMENT, data);
            dispatch(getUserIsAggreed())
        } catch (err) {
            showError(err?.response?.data?.message || 'Something went wrong');
        } finally {
            loaderService.hide();
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='d-flex flex-column gap-24'>
            <h1 className='font-45'>Before We Link to Your Data,</h1>
            <p className='font-18-white'>
                To help you get smarter answers, BrainyAgent needs permission to read the files or data you upload or link.
            </p>
            <p className='font-18-white'>Here’s what that means</p>
            <ul className='info-list'>
                <li>We’ll only look at the data you choose to upload or connect.</li>
                <li>Your data stays private and secure. It’s encrypted and never shared.</li>
                <li>BrainyAgent will use it only to answer your questions.</li>
            </ul>

            <div>
                <div className='color-white d-flex align-items-center gap-8'>
                    <div className='p-12 d-flex'>
                        <input
                            type="checkbox"
                            className="custom-checkbox"
                            id="isAgreed"
                            {...register('isAgreed', {
                                required: 'You must agree before proceeding.'
                            })}
                        />
                    </div>
                    <label htmlFor="isAgreed" className='font-18-white'>
                        I agree to let BrainyAgent access and use my uploaded data to answer my questions.
                    </label>
                </div>
                {errors.isAgreed && (
                    <p className='error-message'>{errors.isAgreed.message}</p>
                )}
            </div>

            <div>
                <button
                    type="submit"
                    className='theme-sky-btn'
                    style={{ borderRadius: '100px' }}
                    disabled={!isAgreed}
                >
                    I Agree
                </button>
            </div>
        </form>
    );
};

export default Consent;
